import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router";

const LocationContext = createContext({ pathname: "/", search: "", hash: "", href: "/" });

export const LocationProvider = ({ children, location: providedLocation }) => {
	const routerLocation = typeof useLocation === "function" ? useLocation() : null;
	const location = providedLocation ?? routerLocation;

	const value = useMemo(() => {
		if (!location) {
			return { pathname: "/", search: "", hash: "", href: "/" };
		}

		const href =
			typeof window !== "undefined" && window.location
				? window.location.href
				: `${location.pathname ?? "/"}${location.search ?? ""}${location.hash ?? ""}`;

		return {
			pathname: location.pathname ?? "/",
			search: location.search ?? "",
			hash: location.hash ?? "",
			href,
		};
	}, [location]);

	return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
};

export const useCurrentLocation = () => useContext(LocationContext);
